<template>
  <RegisterPageLayout>
    <router-view />
  </RegisterPageLayout>
</template>

<script>
import RegisterPageLayout from "./components/RegisterPageLayout.vue";
import { registrationRouteHelper } from "../../helpers/registrationRouteHelper";

export default {
  name: "RegisterPage",
  title: '',
  components: { RegisterPageLayout },
  watch: {
    '$route'(to) {
      this.runOnEachRoute(to.name);
    }
  },
  created() {
    const correctRoute = registrationRouteHelper.evaluate();

    if (this.$route.name !== correctRoute) {
      this.$router.push({ name: correctRoute });
    }

    this.runOnEachRoute(correctRoute);
  },
  methods: {
    runOnEachRoute(pageName) {
      window.scrollTo(0,0);
      // noinspection JSUnusedGlobalSymbols
      this.$title = registrationRouteHelper.pageTitle(pageName);
    }
  }
}
</script>

<style scoped>

</style>